<template>
  <div class="class-detail-section">
    <header v-if="title" class="class-detail-section__header">
      <h3 :id="$attrs.id ? `${$attrs.id}-title` : ''" class="class-detail-section__title">
        <span v-if="hasTitleIcon" class="class-detail-section__title-icon">
          <slot name="title-icon"></slot>
        </span>
        {{ title }}
      </h3>
      <slot name="actions"></slot>
    </header>
    <div class="class-detail-section__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClassDetailSection',

  props: {
    title: {
      type: String,
      default: null,
    },
  },

  computed: {
    hasTitleIcon() {
      return this.$slots['title-icon'];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';

.class-detail-section {
  background-color: rgba(white, 0.05);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding: 16px 35px;
    background: rgba(white, 0.05);
  }

  &__title {
    font-size: 1rem;
    font-weight: 400;
    margin: 0;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  &__title-icon {
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    margin: 3px 4px 0 -16px;
  }

  &__body {
    padding: 1.5rem 35px;
  }

  &__profile__link {
    color: $default-blue;
  }
}
</style>
